import React, { useMemo, useState } from 'react'
import { useHtmlClassService } from '../../_core/MetronicLayout'
import Box from '@mui/material/Box'
import BottomNavigation from '@mui/material/BottomNavigation'
import BottomNavigationAction from '@mui/material/BottomNavigationAction'
import PersonIcon from '@mui/icons-material/Person'
import NotificationsIcon from '@mui/icons-material/Notifications'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import LocalMallIcon from '@mui/icons-material/LocalMall'
import '../../../../sass/custom.scss'
import { useHistory } from 'react-router-dom'
import CustomModal from '../../../../app/components/customModal/CustomModal'
import { useSelector } from 'react-redux'
import Badge from '@mui/material/Badge'
import { red } from '@mui/material/colors'

export function Footer() {
    const { user } = useSelector(state => state.user)
    const [openModal, setOpenModal] = useState(false)
    const history = useHistory()
    const [value, setValue] = React.useState(0)
    const handleOpenModal = () => setOpenModal(true)
    const handleCloseModal = () => setOpenModal(false)

    // -----------------------------------
    const today = new Date().getFullYear()
    const uiService = useHtmlClassService()

    const layoutProps = useMemo(() => {
        return {
            footerClasses: uiService.getClasses('footer', true),
            footerContainerClasses: uiService.getClasses(
                'footer_container',
                true
            ),
        }
    }, [uiService])

    return (
        <>
            {!user.roles.map(item => item.name).includes('customer') ? null : (
                <Box
                    style={{
                        width: '100%',
                        borderBottom: '1px solid #d0d0d0',
                        border: '1px solid #d0d0d0',
                        display:
                            window.location.pathname === '/dashboard' ||
                            window.location.pathname === '/dashboard/'
                                ? 'none'
                                : null,
                    }}
                    className="layout-bottom-naviation"
                >
                    <BottomNavigation
                        showLabels
                        value={value}
                        onChange={(event, newValue) => {
                            setValue(newValue)
                        }}
                    >
                        <BottomNavigationAction
                            label="سفارشات"
                            icon={
                                <Badge
                                    invisible={!user.is_new_order}
                                    color="error"
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }}
                                >
                                    <LocalMallIcon />
                                </Badge>
                            }
                            onClick={() => history.push('/dashboard/myOrder')}
                        />
                        <BottomNavigationAction
                            label="اعلانات"
                            icon={
                                <Badge
                                    badgeContent={user.unSeenAnnouncement}
                                    color="error"
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }}
                                >
                                    <NotificationsIcon />
                                </Badge>
                            }
                            onClick={() =>
                                history.push('/dashboard/notifications')
                            }
                        />
                        <BottomNavigationAction
                            label="پشتیبانی"
                            icon={
                                <Badge
                                    invisible={!user.is_new_ticket}
                                    color="error"
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }}
                                >
                                    <SupportAgentIcon />
                                </Badge>
                            }
                            onClick={() => history.push('/dashboard/tickets')}
                        />
                        <BottomNavigationAction
                            label="کاربری"
                            icon={
                                <Badge
                                    badgeContent={0}
                                    color="error"
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }}
                                >
                                    <PersonIcon />
                                </Badge>
                            }
                            onClick={handleOpenModal}
                        ></BottomNavigationAction>
                    </BottomNavigation>
                </Box>
            )}

            <div>
                {openModal && (
                    <CustomModal
                        route="editUser"
                        type={'editUser'}
                        size="sm"
                        fullWidth={true}
                        show={openModal}
                        closeModal={handleCloseModal}
                        data={user}
                        role="customer"
                    />
                )}
            </div>

            <div
                className={`footer bg-white py-4 flex-lg-column ${layoutProps.footerClasses}`}
                id="kt_footer"
            >
                <div
                    className={`${layoutProps.footerContainerClasses} d-flex flex-column flex-md-row align-items-center justify-content-between`}
                >
                    <div className="text-dark order-2 order-md-1">
                        <span
                            className="text-muted"
                            style={{ fontSize: '12px' }}
                        >
                            کلیه حقوق این سامانه متعلق به صنایع دستی آقاجانی
                            می‌باشد.
                        </span>{' '}
                    </div>
                </div>
            </div>
        </>
    )
}
